import { userStore, types, globalStore } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

const prefixUrl = "";

export default {
    async login(param: types.ReqLogin): Promise<types.ResCommon> {
        const res = {} as types.ResCommon;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/login", param, { withCredentials: false });

            const user = userStore();
            user.setAccessToken(response.data.accessToken);
            user.setRefreshToken(response.data.refreshToken);

            user.setExpiresIn(response.data.expiresIn);

            user.startTimer();

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
    async logout(): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/logout", {}, { withCredentials: false });
            const user = userStore();
            const global = globalStore();
            user.$reset();
            global.$reset();
            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async refresh(refreshToken: types.ReqRefreshToken): Promise<types.ResCommon> {
        const res = {} as types.ResCommon;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/refresh", refreshToken, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async me(): Promise<types.admin.ResUserInfo> {
        const res = {} as types.admin.ResUserInfo;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/me", { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async changePw(param: types.admin.ReqChangePw): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/changePw", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
};
